// extracted by mini-css-extract-plugin
export var completionBody = "_gm-2";
export var completionCard = "_gm-0";
export var completionFooter = "_gm-3";
export var completionTitle = "_gm-1";